import {SharedModule} from 'src/app/shared/shared.module';

export class HomeService {
    constructor() {
    }
}
